import { memo } from 'react';

import { Form } from 'src/shared/components/form/form.js';
import type { KcContext_MagicLinkConfirm } from 'src/shared/utils/kc-context/kc-context.js';
import { useGetMsg } from 'src/shared/utils/kc-messages.js';

import { cnMagicLinkConfirm } from './magic-link-confirm.constants.js';

import './magic-link-confirm.css';

export interface MagicLinkConfirmProps {
    kcContext: KcContext_MagicLinkConfirm;
}

export const MagicLinkConfirm = memo<MagicLinkConfirmProps>(({ kcContext }) => {
    const { url, email } = kcContext;

    const { msgStr } = useGetMsg(kcContext);

    return (
        <Form action={url.loginAction} kcContext={kcContext} className={cnMagicLinkConfirm('content')}>
            <div className={cnMagicLinkConfirm('text-block')}>
                <span className={cnMagicLinkConfirm('title')}>{msgStr('magicLinkConfirm')} </span>
                <span className={cnMagicLinkConfirm('title', { email: true })}>{email || msgStr('yourEmail')}</span>
            </div>
            <div className={cnMagicLinkConfirm('button-container')}>
                <a className={cnMagicLinkConfirm('button')} href={url.loginAction}>
                    {msgStr('magicLinkConfirmButton')}
                </a>
            </div>
        </Form>
    );
});
